import { lazy } from 'react';
const SupplierCreation = lazy(() => import('./SupplierCreation'));

const SupplierCreationRoutes = [
  {
    path: '/supplier-creation',
    component: SupplierCreation
  }
];

export default SupplierCreationRoutes;
